export default __webpack_public_path__ + "static/media/Dex-tool.c2cac2e8.png";